import { useEffect, useState } from "react";
import LoginUser from "../db/LoginUser";
import { LoginAppStates } from "../localStorage";

import { AuthContext } from "./auth-context";
const fireBaseUsersUri =
  "https://login-app-01-01-default-rtdb.firebaseio.com/users.json";

const AuthContextProvider = (props) => {
  const [appStates, setAppStates] = useState(
    LoginAppStates
  );
  const [emailExist, setEmailExist] = useState({
    error: "",
    email: "",
  });
  const [loginReplyStates, setLoginReplyStates] =
    useState({
      isLoading: false,
      error: false,
      reply: "",
    });
  const [
    registerReplyStates,
    setRegisterReplyStates,
  ] = useState({
    isLoading: false,
    error: false,
    reply: "",
  });
  //* functions

  const loginHandler = async (data) => {
    setLoginReplyStates((prevState) => {
      return {
        ...prevState,
        isLoading: true,
        error: false,
        reply: "",
      };
    });
    const USER = await LoginUser(
      fireBaseUsersUri,
      data
    );
    if (USER.dataExist === "valid") {
      setLoginReplyStates((prevState) => {
        return {
          ...prevState,
          isLoading: false,
          error: false,
          reply: "",
        };
      });
      saveUserDataHandler(USER.data);
    } else if (USER.dataExist === "invalid") {
      setLoginReplyStates((prevState) => {
        return {
          ...prevState,
          isLoading: false,
          error: true,
          reply: USER.errorName,
        };
      });
    } else {
      setLoginReplyStates((prevState) => {
        return {
          ...prevState,
          isLoading: false,
          error: true,
          reply: USER,
        };
      });
    }
  };
  const saveUserDataHandler = (data) => {
    setAppStates((prevStates) => {
      return {
        ...prevStates,
        isLoggedIn: true,
        userData: data,
      };
    });
  };
  const signUpHandler = (bool) => {
    setAppStates((prevStates) => {
      return { ...prevStates, toSignUp: bool };
    });
  };
  const logoutHandler = () => {
    setAppStates((prevStates) => {
      return {
        ...prevStates,
        isLoggedIn: false,
        userData: {},
      };
    });
  };
  const saveEmailExistHandler = (
    error,
    email
  ) => {
    setEmailExist((prevState) => {
      return {
        ...prevState,
        error,
        email,
      };
    });
  };
  const saveLoginStateHandler = (
    isLoading,
    error,
    reply
  ) => {
    setLoginReplyStates((prevState) => {
      return {
        ...prevState,
        isLoading,
        error,
        reply,
      };
    });
  };
  const saveRegisterStateHandler = (
    isLoading,
    error,
    reply
  ) => {
    setRegisterReplyStates((prevState) => {
      return {
        ...prevState,
        isLoading,
        error,
        reply,
      };
    });
  };

  useEffect(() => {
    localStorage.setItem(
      "login-app-states",
      JSON.stringify(appStates)
    );
  }, [appStates]);

  return (
    <AuthContext.Provider
      value={{
        appStates,
        emailExist,
        loginReplyStates,
        registerReplyStates,
        isLoggedIn: appStates.isLoggedIn,
        toSignUp: appStates.toSignUp,
        userData: appStates.userData,
        onSignUp: signUpHandler,
        onLogin: loginHandler,
        onLogout: logoutHandler,
        onSaveUserData: saveUserDataHandler,
        onSaveLoginState: saveLoginStateHandler,
        onSaveRegisterState:
          saveRegisterStateHandler,
        onSaveEmailExist: saveEmailExistHandler,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
